import Box from '@prezzee/ribbon-ui/lib/components/Box';
import Button from '@prezzee/ribbon-ui/lib/components/Button';
import { SystemProps } from '@chakra-ui/system';
import Typography from '@prezzee/ribbon-ui/lib/components/Typography';
import CheckIcon from '@prezzee/ribbon-ui/lib/components/icons/CheckIcon';

import useSegment from 'hooks/useSegment';
import { useProduct } from 'contexts/ProductPageContext';

const UpgradeConfirmationBanner = () => {
  const { setHasUpgradedZag } = useProduct();
  const { customElementInteraction } = useSegment();
  const { purchaseInstanceId } = useProduct();

  const handleBackClick = () => {
    setHasUpgradedZag(false);
    customElementInteraction({
      element: 'zag_go_back_cta',
      purchase_instance_id: purchaseInstanceId,
    });
  };

  return (
    <Box {...containerStyles}>
      <Box {...titleContainerStyles}>
        <Box {...iconContainerStyles}>
          <CheckIcon boxSize={4} variant="light" color="purple.400" />
        </Box>
        <Typography variant="h4" as="h2" color="gray.800" fontWeight="semibold">
          You&apos;ve selected a Prezzee Plus eGift Card, great choice!
        </Typography>
      </Box>
      <Typography variant="body" color="gray.600" fontWeight="normal" mb={2}>
        Giftees love these cards as they can choose where to spend them.
      </Typography>
      <Typography variant="body" fontWeight="bold">
        Don&apos;t want a Prezzee Plus eGift Card?
      </Typography>
      <Button
        color="blue.500"
        fontWeight="normal"
        onClick={handleBackClick}
        textDecoration="underline"
        variant="link"
        justifyContent="flex-start"
      >
        Go back
      </Button>
    </Box>
  );
};

const containerStyles: SystemProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: 'lilac.50',
  marginBottom: '4',
  padding: '4',
  borderRadius: 'md',
};

const titleContainerStyles: SystemProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  mb: '3',
};

const iconContainerStyles: SystemProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mr: '4',
  height: '40px',
  width: '40px',
  minHeight: '40px',
  minWidth: '40px',
  backgroundColor: 'white',
  borderRadius: 'full',
  padding: '2',
};

export default UpgradeConfirmationBanner;
